import moment from 'moment';
import styled from 'styled-components';

import { CalendarHolidayItemViewModel } from '@api/v3';

const CalenderDay = styled.span`
  position: relative;
  display: block;
`;

const CalenderEventDay = styled.span`
  width: 4px;
  height: 4px;
  background-color: ${({ theme }) => theme.palette.coral};
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 50%;
`;

export const renderCalendarEvent = (
  day: moment.Moment,
  events: { holidayStartDate: string; holidayEndDate: string }[],
  data?: CalendarHolidayItemViewModel[]
) => {
  const combinedEvents = [
    ...events,
    ...(data?.map((item) => ({
      holidayStartDate: item.holidayStartDate,
      holidayEndDate: item.holidayEndDate,
    })) || []),
  ];

  const isHoliday = combinedEvents.some((event) =>
    moment(day).isBetween(
      moment(event.holidayStartDate),
      moment(event.holidayEndDate),
      'day',
      '[]'
    )
  );

  return (
    <CalenderDay>
      {day.date()}
      {isHoliday ? <CalenderEventDay /> : null}
    </CalenderDay>
  );
};
